import { apiRoutes as hashtagsApiRoutes } from 'hashtags/utils/apiRoutes';
import { apiRoutes as videosApiRoutes } from 'videos/utils/apiRoutes';
import {
  entitiesApiRoutes,
  influencerApiRoutes,
} from 'influencers/utils/apiRoutes';
import { _t } from 'app/utils/i18n';
import { path } from 'app/utils/path';

const MapsApi = [
  {
    label: _t('basic:hashtags'),
    value: hashtagsApiRoutes().countriesMapByCoordinates,
    moduleName: 'hashtags',
    path: path.trends.HASHTAG_VIEW_URI,
  },
  {
    label: _t('basic:videos'),
    value: videosApiRoutes().trendingMap,
    moduleName: 'videos',
    path: path.trends.VIDEO_VIEW_URI,
  },
  {
    label: _t('basic:influencers'),
    value: influencerApiRoutes().influencersMap,
    moduleName: 'influencers',
    path: path.influencers.ANALYZED_INFLUENCER_DETAILS_URI,
  },
  {
    label: _t('basic:entities'),
    value: entitiesApiRoutes().influencersMap,
    moduleName: 'entities',
    path: path.entities.ANALYZED_ENTITIES_DETAILS_URI,
  },
];

export default MapsApi;
